import {NonNegativeInt} from '@raison/types';
import Currency from './Currency';

class CryptoCurrency extends Currency {
    constructor(amount: number | string, decimals_assets?: NonNegativeInt) {
        super(amount, decimals_assets ?? (8 as NonNegativeInt));
        this.transactionsDigits = 8;
    }

    static type = 'crypto';
}

export default CryptoCurrency;
